import React, { useEffect, useState } from "react";
import { getSummarypromptData, getSummarylength } from "../../../services/AdminService";
import { Table, Button } from "react-bootstrap";
import NewSummaryPrompt from "./NewSummaryGenerate";
import EditSummaryPrompt from "./EditSummaryPrompt ";
import DeleteSummaryPrompt from "./DeleteSummaryPrompt ";
import { MdEdit, MdDelete } from "react-icons/md";
import { toast } from "react-toastify";

const GetSummary = ({ type }) => {
    const [summaryData, setSummaryData] = useState([]);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    useEffect(() => {
        fetchSummaryData();
    }, [type]);

    const fetchSummaryData = async () => {
        try {
            const response = type === "document" ? await getSummarypromptData() : await getSummarylength();
            setSummaryData(Array.isArray(response.data) ? response.data : []);
        } catch (error) {
            toast.error("Failed to fetch summary data.");
            setSummaryData([]);
        }
    };

    const updateSummaryData = (updatedData) => {
        setSummaryData(updatedData);
    };

    const handleEdit = (item) => {
        setSelectedItem(item);
        setShowEditModal(true);
    };

    const handleDelete = (item) => {
        setSelectedItem(item);
        setShowDeleteModal(true);
    };

    return (
        <section>
            <div className="d-flex justify-content-between align-items-center my-4">
                <h2 className="text-white">{type === "document" ? "Document Prompt Data" : "Length Prompt Data"}</h2>
                <Button variant="primary" onClick={() => setShowCreateModal(true)}>
                    Add {type === "document" ? "Document" : "Length"} Prompt
                </Button>
            </div>

            <Table striped bordered hover style={{ borderRadius: "12px" }}>
                <thead>
                    <tr>
                        <th style={{ width: "15%" }}>{type === "document" ? "Document Type" : "Length Type"}</th>
                        <th style={{ width: "75%" }}>Prompt Instruction</th>
                        <th style={{ width: "10%" }}>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {summaryData.length > 0 ? (
                        summaryData.map((item) => (
                            <tr key={item.id}>
                                <td style={{ width: "15%" }}>{type === "document" ? item.document_type : item.length_type}</td>
                                <td style={{ width: "75%" }}>{item.instruction_text}</td>
                                <td style={{ width: "10%" }}>
                                    <button
                                        className="btn btn-warning btn-sm me-2 custom-tooltip"
                                        onClick={() => handleEdit(item)}
                                        data-bs-title="Edit Prompt Data"
                                    >
                                        <MdEdit size={18} color="white" />
                                    </button>

                                    <button
                                        className="btn btn-danger btn-sm custom-tooltip"
                                        onClick={() => handleDelete(item)}
                                        data-bs-title="Delete Prompt Data"
                                    >
                                        <MdDelete size={18} color="white" />
                                    </button>
                                </td>

                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="3" className="text-center">No data available</td>
                        </tr>
                    )}
                </tbody>
            </Table>

            <NewSummaryPrompt
                type={type}  // Ye missing tha, ab add kar diya hai ✅
                show={showCreateModal}
                handleClose={() => setShowCreateModal(false)}
                updateSummaryData={updateSummaryData}
                fetchSummaryData={fetchSummaryData}
                currentData={summaryData}
            />

            <EditSummaryPrompt
                type={type}
                show={showEditModal}
                handleClose={() => setShowEditModal(false)}
                item={selectedItem}
                updateSummaryData={updateSummaryData}
                fetchSummaryData={fetchSummaryData}
            />
            <DeleteSummaryPrompt
                type={type}
                show={showDeleteModal}
                handleClose={() => setShowDeleteModal(false)}
                item={selectedItem}
                updateSummaryData={updateSummaryData}
                fetchSummaryData={fetchSummaryData}
            />
        </section>
    );
};

export default GetSummary;